﻿import $ from 'jquery';
import { initCookieConsent } from './cookie-consent';
import { initContactForm } from './contact-form';

$(document).ready(() => {
    initContactForm();
    initCookieConsent();

    //Tabs
    $('.tab-content-container').hide();

    $('.tabs .tab-title').click(function () {

        if ($(this).hasClass("tab-active")) {

            $('.tab-content-container').slideUp(500);
            $('.tabs .tab-title').removeClass("tab-active");
        }

        else {

            $('.tabs .tab-title').removeClass("tab-active");
            $(this).toggleClass("tab-active");
            $('.tab-content-container').hide();
            $($('.tab-content-container')[$(this).index()]).slideDown(500);
        }

    });

    $('.tab-close').click(function () {

        $('.tab-content-container').slideUp(500);
        $('.tabs .tab-title').removeClass("tab-active");

    });

    //Menu toggle
    $('.nav-icon').click(function () {

        $(".nav-icon").toggleClass("active");
        $(".main-navigation").toggleClass("active");
        $(".page-overlay").toggleClass("active");
        event.preventDefault();

    });

    if ($(window).width() > 1113) {

        //Menu hover
        $(".menu-parent").hover(function () {
            $(this).find(".hover-menu").addClass("active");
        }, function () {
            $(".hover-menu").removeClass("active");
            $(".Level2").removeClass("active");
        });

        //Level 1
        $(".Level1 li").on("mouseover", function () {

            $(".Level2").removeClass("active");
            $(this).find(".Level2").addClass("active");

        });

    } else {

        $(".menu-parent").on("click", function () {

            if (!$(this).hasClass("clicked")) {
                event.preventDefault()
                console.log("not clicked");
            }

            $(".menu-parent").removeClass("clicked");
            $(this).addClass("clicked");

            $(".hover-menu").removeClass("active");
            $(this).find(".hover-menu").addClass("active");

        });

        $(".Level1 li").on("click", function (event) {

            console.log(event.target);

            if ($(event.target).parents(".Level2").length == 0) {
                if (!$(this).hasClass("clicked")) {
                    event.preventDefault()
                }

                $(".Level1 li").removeClass("clicked");
                $(this).addClass("clicked");

                $(".Level2").removeClass("active");
                $(this).find(".Level2").addClass("active");
            }
        });

    }

    //Search toggle
    $('.search-toggler').click(function () {

        $(".search-holder").toggleClass("active");
        event.preventDefault();

    });

    //faq toggle
    $(".faq-item .question").click(function () {

        $(this).toggleClass("active");
        $(this).next(".answer").toggle(100);
    });

    $(window).on('load', function () {
        var readMessages = JSON.parse(localStorage.getItem("readwarningmessages") || "[]");
        var $openButton = $(".open-message");
        var nrOfWarnings = 0;

        $.get("/umbraco/api/warningmessages/get", function (warnings) {
            console.log("warnings.length " + warnings.length)
            if (warnings.length) {
                init(warnings)

                if (readMessages.length) {
                    removeOldWarnings(warnings, readMessages)
                }
            }
            else {
                removeRemoteMessage()
            }

        })
            .fail(function (resp) {
                //console.log("Error getting warning messages!");
                //console.log(resp);
            })

        function init(warnings: any) {
            $.each(warnings, function (i, warning) {
                console.log(warning);
                //var m = warning.Link ? "<a href='" + warning.Link + "'>" + warning.Message + "</a>" : warning.Message;

                var m = "";

                if ($(".warning-message-link").length) {

                    var messageLink = $(".warning-message-link").val();

                    m = "<p>" + warning.title + "</p><br /><a class='warning-button' href='" + messageLink + "'>Mer information</a>";
                }
                else {

                    m = "<p>" + warning.title + "</p>";
                }

                var $el = $("<div class='warning-message icon'></div>")
                    .append("<div class='message'><div class='w-icon'></div>" + m + "</div>")
                    .append("<div class='close-warning icon'></div>");

                $el.appendTo("#warning-messages")

                var $remoteMessage = $("<div class='remote-disruption-message'><p class='remote-header'>" + warning.title + "</p><p>" + warning.message + "</div>")

                var $driftstausHeader = $("<p>" + warning.title + "</p>")
                var $driftstausText = $("<p>" + warning.message + "</p>")
                //$driftstausHeader.appendTo(".remote-disruption-header")
                //$driftstausText.appendTo(".remote-disruption-text")
                $remoteMessage.appendTo("#remote-disruption-group")

                if (readMessages.indexOf(warning.Message) > -1) {
                    $el.addClass('hide');
                }

                nrOfWarnings++;
            })

            toggleMessagesAndOpenButton()

            $(".close-warning").click(function () {
                var $warning = $(this).parents(".warning-message").first();
                var warningText = $warning.find('.message').text();
                $warning.addClass('hide');

                toggleMessagesAndOpenButton()

                if (readMessages.indexOf(warningText) === -1) {
                    readMessages.push(warningText);
                    localStorage.setItem("readwarningmessages", JSON.stringify(readMessages));
                }
            });
        }

        function removeRemoteMessage() {
            console.log("Ta bort remote-disruption-group")
            var remoteDisruptionGroup = $("#remote-disruption-group");
            var $dummyText = $("<p></p>")
            $dummyText.appendTo("#remote-disruption-group")
            remoteDisruptionGroup.remove();
        }

        $(".open-message").click(function () {
            $('.warning-message').removeClass('hide');
            $openButton.addClass('hide');
            console.log("open");
        });

        function toggleMessagesAndOpenButton() {
            if ($('.warning-message.hide').length) {
                $openButton.removeClass('hide')
            }
            else {
                $openButton.addClass('hide')
            }
        }

        function removeOldWarnings(warnings: any, readMessages: any) {
            if (warnings.length) {
                var newReadMessages: any = [];

                $.each(warnings, function (i, warning) {

                    newReadMessages.push(warning.Message)

                })
            }

            localStorage.setItem("readwarningmessages", JSON.stringify(newReadMessages));
        }

    });

});
